"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _awsAmplify = _interopRequireWildcard(require("aws-amplify"));

var _client = require("@apollo/client");

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _reactGa = _interopRequireDefault(require("react-ga"));

var _styles = require("@material-ui/core/styles");

var _pickers = require("@material-ui/pickers");

var _moment = _interopRequireDefault(require("@date-io/moment"));

var _useAppSyncClient = _interopRequireDefault(require("../Hooks/useAppSyncClient"));

var _CurrentUser = require("../Contexts/CurrentUser");

var _AppBar = require("./Contexts/AppBar");

var _useCurrentUser = _interopRequireDefault(require("../Hooks/useCurrentUser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AppWithCognitoUser = function AppWithCognitoUser(_ref) {
  var cognitoUser = _ref.cognitoUser,
      children = _ref.children,
      useFindUser = _ref.useFindUser,
      useCreateUser = _ref.useCreateUser,
      useUpdateUser = _ref.useUpdateUser,
      useNotificationPermissions = _ref.useNotificationPermissions;
  var currentUser = (0, _useCurrentUser["default"])({
    cognitoUser: cognitoUser,
    useNotificationPermissions: useNotificationPermissions,
    useFindUser: useFindUser,
    useCreateUser: useCreateUser,
    useUpdateUser: useUpdateUser
  });
  return /*#__PURE__*/_react["default"].createElement(_CurrentUser.CurrentUserProvider, {
    currentUser: currentUser
  }, typeof currentUser === 'undefined' ? null : /*#__PURE__*/_react["default"].createElement(_AppBar.AppBarProvider, null, children));
};

var _default = function _default(_ref2) {
  var children = _ref2.children,
      theme = _ref2.theme,
      sentryUrl = _ref2.sentryUrl,
      amplifyConfig = _ref2.amplifyConfig,
      ga = _ref2.ga,
      useFindUser = _ref2.useFindUser,
      useCreateUser = _ref2.useCreateUser,
      useUpdateUser = _ref2.useUpdateUser,
      useNotificationPermissions = _ref2.useNotificationPermissions;

  var _useState = (0, _react.useState)(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      cognitoUser = _useState2[0],
      setCognitoUser = _useState2[1];

  var appsyncClient = (0, _useAppSyncClient["default"])({
    cognitoUser: cognitoUser,
    appSyncConfig: amplifyConfig
  });
  (0, _react.useEffect)(function () {
    _awsAmplify.Auth.currentAuthenticatedUser({
      bypassCache: true
    }).then(function (cognitoUser) {
      return setCognitoUser(cognitoUser);
    })["catch"](function (err) {
      return setCognitoUser(null);
    });

    _awsAmplify["default"].configure(amplifyConfig);

    !!sentryUrl && Sentry.init({
      dsn: sentryUrl
    });
    !!ga && _reactGa["default"].initialize(ga);
  }, []);
  (0, _react.useEffect)(function () {
    var onAuthEvent = function onAuthEvent(capsule) {
      switch (capsule.payload.event) {
        case 'signOut':
          setCognitoUser(null);

          _reactGa["default"].event({
            category: 'Authentication',
            action: 'signOut'
          });

          break;

        case 'signIn_failure':
          _reactGa["default"].event({
            category: 'Authentication',
            action: 'signIn_failure'
          });

          break;

        case 'signUp_failure':
          _reactGa["default"].event({
            category: 'Authentication',
            action: 'signUp_failure'
          });

          break;

        case 'signIn':
          setCognitoUser(capsule.payload.data);

          _reactGa["default"].event({
            category: 'Authentication',
            action: 'signIn'
          });

          break;

        case 'signUp':
          setCognitoUser(capsule.payload.data);

          _reactGa["default"].event({
            category: 'Authentication',
            action: 'signUp'
          });

          break;

        default:
          break;
      }
    };

    _awsAmplify.Hub.listen('auth', onAuthEvent);

    return function () {
      return _awsAmplify.Hub.remove(('auth', onAuthEvent));
    };
  }, []);
  return !appsyncClient ? null : /*#__PURE__*/_react["default"].createElement(_pickers.MuiPickersUtilsProvider, {
    utils: _moment["default"]
  }, /*#__PURE__*/_react["default"].createElement(_client.ApolloProvider, {
    client: appsyncClient
  }, /*#__PURE__*/_react["default"].createElement(_styles.MuiThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(AppWithCognitoUser, {
    appsyncClient: appsyncClient,
    cognitoUser: cognitoUser,
    useFindUser: useFindUser,
    useCreateUser: useCreateUser,
    useUpdateUser: useUpdateUser,
    useNotificationPermissions: useNotificationPermissions
  }, children))));
};

exports["default"] = _default;